import request from '@/utils/request';
const Login = params => request.post('/admin/login', params);
const Api = {
  EnrollList: params => request.get('/admin/enroll/list', {
    params: params
  })
};
export { Login, Api };